<template>
  <div class="c-account">
    <acFilter
      placeholder="请输入计划账号或者计划主ID"
      :syncLoading="syncLoading"
      :open="open"
      :opIds="opUserList"
      @on-open="openNewEntry"
      @on-change="filterData"
      @on-search="searchFilterData"
      @on-syncData="syncData"
      @on-downData="downData"
    />

    <div class="c-m-table">
      <Viewport v-model="tableHeight">
        <acTable
          ref="aTable"
          :loading="loading"
          :data="tableList"
          :columns="columns"
          :media="mediaVal"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-show="handleShow"
          @on-select="select"
          @header-dragend="headerDragend"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import acFilter from '@/components/converter/filter-account.vue'
import acTable from '@/components/converter/table/table-account.vue'

import { TOUTIAO_COLMUNS, TENCENT_COLMUNS, KS_COLMUNS, BAIDU_COLMUNS, UC_COLMUNS } from '../data/account_ad_column.js'
import { isArray } from '@/common/js/utils'
import { listAdAccountData, syncAdAccountInfo } from '@/api/convert.model'
import { adPtom } from '@/api/common.model'

import { HOST_API } from '@/api/config'
export default {
  name: 'AccountList',
  mixins: [mixin],
  components: { acFilter, acTable },
  computed: {
    mediaVal() {
      return parseInt(this.$route.params.id)
    },
    open() {
      let title
      if (this.mediaVal === 10) title = '投放计划'
      else if (this.mediaVal === 6) title = '推广计划'
      else if (this.mediaVal === 16) title = '计划'
      else if (this.mediaVal === 45) title = '推广单元'
      else if (this.mediaVal === 32) title = '计划组'
      return title
    },
    custom() {
      let custom
      if (this.mediaVal === 10) custom = 'account'
      else if (this.mediaVal === 6) custom = 'ucaccount'
      else if (this.mediaVal === 16) custom = 'teaccount'
      else if (this.mediaVal === 45) custom = 'bdaccount'
      else if (this.mediaVal === 32) custom = 'ksaccount'
      return custom
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.aTable && this.$refs.aTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        mediaId: this.mediaVal,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      listAdAccountData(params).then((data) => {
        this.loading = false
        if (!data) return
        const { list, page_info } = data
        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
          this.tableList = list.map((e) => {
            e.editState = false
            e.editBudget = false
            e.day_budget_schedule = isArray(e.day_budget_schedule) ? e.day_budget_schedule : '不限'
            return e
          })
        }
        this.$nextTick(() => {
          this.$refs.aTable && this.$refs.aTable.doLayout()
        })
      })
    },
    handleShow(params) {
      const { key, row } = params
      var query = {
        adAccountId: row.adAccountId
      }
      if (key === 'validPlanCounts') {
        query.isValidPlan = 1 // 筛选投放中计划
      }
      if (this.mediaVal === 6) {
        query.id = -new Date()
        this.$router.push({
          name: 'plan',
          query: query
        })
      } else {
        this.$store.commit('setIndexRoute', 'account')
        query.name = encodeURI(row.adAccount)
        query.media = this.mediaVal
        this.$router.push({
          name: 'advert',
          query: query
        })
      }
    },
    select(val) {
      this.selectList = val
    },
    downData() {
      let url = `${HOST_API}/api/ptom/media-account/down`
      url += `?sessionid=${this.$store.state.token}`
      url += `&mediaId=${this.params.mediaId}`
      url += `&queryBeginTime=${this.params.queryBeginTime}`
      url += `&queryEndTime=${this.params.queryEndTime}`
      this.params.keyWord && (url += `&keyWord=${this.params.keyWord}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    syncData() {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何账号，请在列表中选择一个或多个账号再进行此操作。'
        })
        return
      }
      this.syncLoading = true
      const accountIds = this.selectList.map((e) => e.adAccountId).join(',')
      syncAdAccountInfo({ accountIds }).then((ret) => {
        this.syncLoading = false
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    getPreloadData() {
      Promise.all([adPtom({ authFlag: 1 })]).then((data) => {
        const [opIds] = data
        this.opUserList = opIds || []
      })
    }
  },
  data() {
    return {
      tableHeight: 330,
      loading: null,
      syncLoading: null,
      accountIds: '',
      columns: [], // 表格字段
      tableList: [], // 表格数据
      selectList: [],
      opUserList: []
    }
  },
  created() {
    let columns
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    if (this.mediaVal === 10) columns = TOUTIAO_COLMUNS
    else if (this.mediaVal === 16) columns = TENCENT_COLMUNS
    else if (this.mediaVal === 32) columns = KS_COLMUNS
    else if (this.mediaVal === 45) columns = BAIDU_COLMUNS
    else if (this.mediaVal === 6) columns = UC_COLMUNS
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
    this.tableList.length && this.getData()
    this.getPreloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-account {
  height: 100%;
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
